import React, { useEffect, useState } from 'react'
import { CalendarOutlined } from '@ant-design/icons';
import { Grid } from '@material-ui/core';
import { Button, Card, Col, Row } from 'antd';
import DetailItem from '../../../../../CSIComponents/DetailItem';
import PageContainer from '../../../../../CSIComponents/PageContainer';

const AMOUNT = 'Amount';
const PERCENT = 'Percent';

const TaxDetails = (props: any) => {
  const rowDetail = JSON.parse(JSON.stringify(props.cancellationDetails))
  const [detailData, setDetailData] = useState<Array<any>>([])

  let _detailData = [
    { label: 'Policy Name', value: rowDetail.name, span: 6 },
    { label: 'date', span: 12 },
    { span: 6 },
    { label: 'Tax Type', value: rowDetail.taxtype, span: 6 },
    { label: 'Type', value: rowDetail.type, span: 6 },
    { label: 'Charge Type', value: rowDetail.chargetype, span: 6 }, 
    { span: 6 }
  ]
  useEffect(() => {
    if (rowDetail.chargetype === AMOUNT) {
      _detailData[7] = { label: 'Charge (Amount)', value: rowDetail.chargeamount, span: 6 }
      _detailData[8] = { label: 'Currency', value: rowDetail.currency, span: 6 }
      _detailData[9] = { label: 'Charge Frequency', value: rowDetail.chargefrequency, span: 6 }
      _detailData[10] =  { span: 6 }
      _detailData[11] =  { label: 'Charge Unit', value: rowDetail.chargeunit, span: 6 }
      _detailData[12] =  { label: 'Sequence', value: rowDetail.sequence, span: 6 }
      _detailData[13] =  { label: 'Description', value: rowDetail.description, span: 18 }

    } else if (rowDetail.chargetype === PERCENT) {
      _detailData[7] = { label: 'Charge (Percent)', value: rowDetail.chargeamount, span: 6 }
      _detailData[8] = { label: 'Charge Frequency', value: rowDetail.chargefrequency, span: 6 }
      _detailData[9] =  { label: 'Charge Unit', value: rowDetail.chargeunit, span: 6 }
      _detailData[10] =  { span: 6 }
      _detailData[11] =  { label: 'Sequence', value: rowDetail.sequence, span: 6 }
      _detailData[12] =  { span: 6 }
      _detailData[13] =  { span: 6 }
      _detailData[14] =  { label: 'Description', value: rowDetail.description, span: 18 }
    }else{
      _detailData[7] = { label: 'Charge ()', value: rowDetail.chargeamount, span: 6 }
      _detailData[8] = { label: 'Charge Frequency', value: rowDetail.chargefrequency, span: 6 }
      _detailData[9] =  { label: 'Charge Unit', value: rowDetail.chargeunit, span: 6 }
      _detailData[10] =  { span: 6 }
      _detailData[11] =  { label: 'Sequence', value: rowDetail.sequence, span: 6 }
      _detailData[12] =  { span: 6 }
      _detailData[13] =  { span: 6 }
      _detailData[14] =  { label: 'Description', value: rowDetail.description, span: 18 }
    }
    setDetailData(_detailData)
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [])
  
  return <><PageContainer>
    <Card style={{ marginTop: -15 }}>
      <Grid container spacing={0} className="containerSpacing py-0">
        <Grid item xs={12} className="p-0">
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>{rowDetail.name}</div>
            {/* <div><Button style={{ background: '#004771', color: '#fff', width: 60, height: 28 }} onClick={() => { editHandle(); props.isEditable(); props.disableTabPanes(true) }}>Edit</Button></div> */}
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={{margin: '0 10px 0 0'}}>
                        <Button className="db-edit-btn" onClick={() => { props.setActiveTabKey('Taxes') }}>Back</Button>
                    </div>
                    <div><Button className="db-edit-btn" onClick={() => { props.toggleToEditMode(); }}>Edit</Button></div>
              </div>
          </div>
        </Grid>
        <Grid item xs={12} className="pb-0 px-0 my-0">
          <Row gutter={24}>
            {
              detailData.map((item: any, i) => {
                return item.label === 'date' ? <Col span={item.span} key={i} className="col-margin">
                  <div style={{ display: 'inline-block', width: '100%' }}>
                    <div style={{ fontSize: 12, color: '#999999', height: '24px', "fontWeight": 600 }}>Effective Date ~ Discontinue Date</div>
                    <div style={{ display: 'flex', width: '100%', textOverflow: 'ellipsis', borderBottom: '1px solid #CCCCCC', padding: '0 5px', fontSize: '14px', height: '32px', marginTop: '5px', lineHeight: '32px', overflow: 'hidden', color: '#333333' }}>
                      <div style={{ flex: 1 }}>{rowDetail.startdate}</div>
                      <span style={{ padding: '0 10px', marginLeft: -20 }}>~</span>
                      <div style={{ flex: 1 }}>{rowDetail.enddate}
                        <CalendarOutlined style={{ float: 'right', marginTop: 10 }} />
                      </div>
                    </div>
                  </div>
                </Col> : item.label ? <Col span={item.span} key={i} className="col-margin">
                  <DetailItem value={item.value} label={item.label} />
                </Col> : <Col span={item.span} key={i}></Col>
              })
            }
          </Row>
        </Grid>
      </Grid>
    </Card>
  </PageContainer>
  </>
}
export default TaxDetails;
